import { FaArrowUp, FaArrowDown, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import styles from "../screens/wbauto/EmptyGateOut.module.css";

function FloatingActions({ topRef, bottomRef }) {
  const navigate = useNavigate();

  return (
    <div className={styles.fabStack}>
      <button
        className={styles.fabBtn}
        onClick={() =>
          topRef.current?.scrollIntoView({ behavior: "smooth" })
        }
      >
        <FaArrowUp />
      </button>

      <button
        className={styles.fabBtn}
        onClick={() =>
          bottomRef.current?.scrollIntoView({ behavior: "smooth" })
        }
      >
        <FaArrowDown />
      </button>

      <button
        className={`${styles.fabBtn} ${styles.homeFab}`}
        onClick={() => navigate("/dashboard")}
      >
        <FaHome />
      </button>
    </div>
  );
}

export default FloatingActions;
